export const normalizeText = (text = '') => {
  const splitted = text.split('_');

  return splitted.map((s) => s.substring(0, 1).toUpperCase() + s.substring(1, s.length).toLowerCase()).join(' ');
};
